import { render, staticRenderFns } from "./dialog-timer.vue?vue&type=template&id=4f55b68c"
import script from "./dialog-timer.vue?vue&type=script&lang=js"
export * from "./dialog-timer.vue?vue&type=script&lang=js"
import style0 from "./dialog-timer.vue?vue&type=style&index=0&id=4f55b68c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports